const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://eeiyqmrxxlwmetitkcrs.supabase.co";

let cached: string | null | undefined;

export async function getWcProjectId(): Promise<string | null> {
  // Return from env if available at build time
  const fromEnv = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim().match(/[a-f0-9]{32}/i)?.[0];
  if (fromEnv) return fromEnv;

  // Return cached value
  if (cached !== undefined) return cached;

  try {
    const res = await fetch(`${SUPABASE_URL}/functions/v1/wc-config`, {
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json();
    cached = data.projectId || null;
  } catch {
    cached = null;
  }
  return cached;
}
